<template>
  <b-row>
    <b-col>
      <div class="text-right" :class="{ 'col-md-12': vfg }">
        <b-button
          @click="$emit('submit')"
          class="btn-anchor raised"
        >
          {{ title }}
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default() { return 'Submit'; },
    },
    vfg: {
      type: Boolean,
      default: false,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/buttons/form/SubmitButton.vue